import React, { useContext } from 'react';
import { PageContext } from '@axiom/ui';

import DefaultLayout from '../layouts/default';
import { BenchView } from '../components/BenchView/BenchView';

export const BenchPage = ({ name }: { name?: string }) => {
  const { setTitle } = useContext(PageContext);
  setTitle('Bench');
  return (
    <div data-test="BENCH_PAGE">
      <DefaultLayout>
        <BenchView />
      </DefaultLayout>
    </div>
  );
};
